module.exports = __webpack_public_path__ + "static/media/heart-2.fd7baf96.svg";